module.exports = __webpack_public_path__ + "img/1alB-m-dam.d91ed04a.jpg";